export const MAIN_APP = process.env.PUBLIC_URL;
export const ZONES_PAGE = MAIN_APP + "/";
export const TICKETS_PAGE = MAIN_APP + "/ticketsPage";
export const EXERCISE_PAGE = MAIN_APP + "/exercisePage";
export const FINALIZE_PAGE = MAIN_APP + "/finalizePage";
export const PASS_PAGE = MAIN_APP + "/passPage";
export const REALIZE_VOUCHER_PAGE = MAIN_APP + "/realizeVoucherPage";
